type FormLinks = {
  title: string;
  urlParam: string;
  page: string;
};

export const hasFormLink = (title: string, configFormLinks?: FormLinks[]) => {
  if (!configFormLinks) return undefined;
  const clean = (str: string) => str.trim().toLowerCase();
  return configFormLinks.find((item) => clean(item.title) === clean(title));
};
